import React from "react";
import { useFormContext } from "react-hook-form";
import { clsx } from "clsx";
import TextareaAutosize from "react-textarea-autosize";

interface Props {
  name: string;
  placeholder?: string;
  className?: string;
  maxRows?: number;
}

export const FormTextArea: React.FC<Props> = ({ name, ...props }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const error = errors[name]?.message as string;

  const className = clsx(props.className, {
    "flex w-full rounded-md border border-input bg-background p-3 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50": true,
    "!border-red-500 mb-1": !!error,
  });

  return (
    <>
      <TextareaAutosize {...register(name)} {...props} className={className} minRows={3} />
      {error && <p className="mb-2 text-xs text-red-500">{error}</p>}
    </>
  );
};
